<div *ngIf="this.isLoggedIn(); then loggedIn; else loggedOut"></div>
<ng-template #loggedIn>
	{{ this.name }}
	<button mat-button obButton="tertiary" (click)="logout()">
		Logout
		<mat-icon svgIcon="logout"></mat-icon>
	</button>
</ng-template>
<ng-template #loggedOut>
	<button mat-button obButton="tertiary" (click)="login()">
		Login
		<mat-icon svgIcon="login"></mat-icon>
	</button>
</ng-template>
